module.exports = __webpack_public_path__ + "static/WEB0-ba4dd722e540fcb0890eb11cae85bda7.jpg";